import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef, useState, useEffect, useCallback, useMemo } from 'react';
import '../LoaderDots/index.mjs';
import { StyledButton, InnerWrap, LoaderDotsWrap } from './Button.styles.mjs';
import { LoaderDots } from '../LoaderDots/LoaderDots.mjs';
"use strict";
const BUTTON_LOADING_DELAY_MS = 2e3;
const Button = forwardRef(function Button2({
  children,
  anchor,
  span,
  size = "medium",
  loading: loadingInitial,
  loadAfterAction,
  disabled,
  onClick,
  ...args
}, ref) {
  const [loading, setLoading] = useState(!!loadingInitial);
  useEffect(() => {
    setLoading(!!loadingInitial);
  }, [loadingInitial]);
  const onClickCustom = useCallback(e => {
    if (loading || disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (onClick) {
      onClick(e);
      if (loadAfterAction) {
        setLoading(true);
        setTimeout(() => setLoading(false), BUTTON_LOADING_DELAY_MS);
      }
    }
  }, [disabled, loading, loadAfterAction, onClick]);
  const loaderDotsColor = useMemo(() => {
    if (args.variant === "secondary") {
      return "primaryBlue";
    }
    return "white";
  }, [args.variant]);
  const elementType = (() => {
    if (anchor) return "a";
    if (span) return "span";
    return void 0;
  })();
  return /* @__PURE__ */jsx(StyledButton, {
    ...args,
    as: elementType,
    disabled: disabled || loading,
    size,
    $loading: loading,
    onClick: onClickCustom,
    ref,
    children: /* @__PURE__ */jsxs(InnerWrap, {
      children: [loading && /* @__PURE__ */jsx(LoaderDotsWrap, {
        children: /* @__PURE__ */jsx(LoaderDots, {
          color: loaderDotsColor,
          size: size === "large" ? "large" : void 0
        })
      }), children]
    })
  });
});
export { BUTTON_LOADING_DELAY_MS, Button };
//# sourceMappingURL=Button.mjs.map
